export const REMOVE_FROM_ACTIVE_RANGE_SHOW = 'REMOVE_FROM_ACTIVE_RANGE_SHOW';
export const REMOVE_FROM_ACTIVE_RANGE_RESET = 'REMOVE_FROM_ACTIVE_RANGE_RESET';
export const REMOVE_FROM_ACTIVE_RANGE_IN_PROGRESS =
  'REMOVE_FROM_ACTIVE_RANGE_IN_PROGRESS';
export const REMOVE_FROM_ACTIVE_RANGE_DONE = 'REMOVE_FROM_ACTIVE_RANGE_DONE';
